import { ChevronLeft, ChevronRight } from 'lucide-react';

import { ReorderableHeaderProps } from './types';
import * as Styled from './SendCompedTicketsModal.styles';

const widthByHeader: Record<string, { width: string; minWidth: string }> = {
	Email: { width: '40%', minWidth: '250px' },
	'First Name': { width: '20%', minWidth: '150px' },
	'Last Name': { width: '20%', minWidth: '150px' },
	Quantity: { width: '20%', minWidth: '100px' },
	'Ticket Type': { width: '20%', minWidth: '120px' },
};

export const ReorderableHeader = ({
	header,
	onMoveLeft,
	onMoveRight,
	canMoveLeft,
	canMoveRight,
}: ReorderableHeaderProps) => {
	const dimensions = widthByHeader[header] || { width: '25%', minWidth: '120px' };

	return (
		<Styled.HeaderCell width={dimensions.width} minWidth={dimensions.minWidth} data-header={header}>
			<Styled.HeaderInner>
				<Styled.HeaderLabel>{header}</Styled.HeaderLabel>
				<Styled.ArrowsWrapper>
					<Styled.ArrowButton
						type="button"
						onClick={onMoveLeft}
						disabled={!canMoveLeft}
						title="Move left"
						aria-label="Move column left"
					>
						<ChevronLeft size={12} />
					</Styled.ArrowButton>
					<Styled.ArrowButton
						type="button"
						onClick={onMoveRight}
						disabled={!canMoveRight}
						title="Move right"
						aria-label="Move column right"
					>
						<ChevronRight size={12} />
					</Styled.ArrowButton>
				</Styled.ArrowsWrapper>
			</Styled.HeaderInner>
		</Styled.HeaderCell>
	);
};
